import { computed } from "vue";
import { useRequirementsStore } from "@/stores";
import { STANDARD_COPY_DETAILS_FIELDS } from "@/utils/submissionClipboard";
/** The loaded company's Copy Details fields in template order; the standard template when none are saved or known. */
export function useCopyDetailsFields() {
    const requirementsStore = useRequirementsStore();
    const config = computed(() => requirementsStore.clientConfig);
    const isActiveCompanyConfig = computed(() => config.value !== null && requirementsStore.clientConfigIsActiveCompany);
    const fields = computed(() => {
        const saved = config.value?.priorAuth?.copyDetailsFields ?? [];
        const known = STANDARD_COPY_DETAILS_FIELDS.filter((key) => saved.includes(key));
        return known.length ? known : STANDARD_COPY_DETAILS_FIELDS;
    });
    async function ensureActiveCompanyConfig() {
        if (config.value && !isActiveCompanyConfig.value)
            await requirementsStore.refreshCurrentUserClientConfig();
    }
    function applySaved(saved) {
        if (isActiveCompanyConfig.value && config.value)
            config.value.priorAuth.copyDetailsFields = saved;
    }
    return { fields, isActiveCompanyConfig, ensureActiveCompanyConfig, applySaved };
}
